import React, { useContext } from "react";

// Components //
import OpenTalents from "../open-talent/openTalents";
import Loading from "../../atoms/loading/loading";

// Context //
import TalentsContext from "../../../contexts/talentsContext";

interface ListOpenTalentsProps {
    talentsSelectedIds: any,
    setTalentsSelectedIds: any,
    talentsHelper: any,
    setTalentsHelper: any
}

const ListOpenTalents = (props:ListOpenTalentsProps) => {

    const {
        talentsSelectedIds,
        setTalentsSelectedIds,
        talentsHelper,
        setTalentsHelper
    } = props;

    const { talents, loading } = useContext(TalentsContext);

    //Bloque creado para almacenar los talentos seleccionados y usarlos en el formulario grupal//
    const handleChange = (event) => {
        const { checked, value } = event.target;
        let updatedIds;

        if (checked) {
          if (talentsSelectedIds.length < 10) {
            //Si NO existe el numero de documento (value) lo agrega
            updatedIds = [...talentsSelectedIds, value];
          } else {
            //Si hay 10 seleccionados, no deja agregar mas
            event.preventDefault();
            updatedIds = talentsSelectedIds;
          }
        } else {
          //Si ya existe el numero de documento (value) lo elimina
          updatedIds = talentsSelectedIds.filter((selectedId) => selectedId !== value);
          setTalentsHelper(talentsHelper.filter((talent) => talent.numeroDocumento !== value));
        }
      
        setTalentsSelectedIds(updatedIds);
    }
    //Bloque creado para almacenar los talentos seleccionados y usarlos en el formulario grupal//
    
    return (
        <>
            {(() => {
                if (loading) {
                    return <Loading />;
                } else if (talents && talents.length > 0) {
                    return talents.map((item, index) => (
                        // TODO - filtros
                        <OpenTalents 
                            key={index}
                            {...item}
                            handleChange={handleChange}
                            talentsSelectedIds={talentsSelectedIds}
                        />
                    ));
                } else {
                    return (
                        <div className="container-encontrar-talento__notfound">
                            <span>¡Vaya!</span>
                            <p>
                                No se encontraron talentos con los criterios de
                                búsqueda seleccionados.
                            </p>
                        </div>
                    );
                }
            })()}
        </>
    );
};

export default ListOpenTalents;
